import * as actionTypes from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    products: null,
    fetchPaymentChannels: null,
    users: null,
    total: 0,
    filter: {
        page: 1,
        pageSize: 10,
        searchKey: "",
        plan: null,
        startDate: null,
        endDate: null,
        subscription: null,
        sortKey: "email",
        sortDirection: "asc",
    },
    selectedUser: null,
};

const updateProducts = (state, action) => {
    return updateState(state, {
        products: action.products,
    });
};

const updatePaymentChannels = (state, action) => {
    return updateState(state, {
        paymentChannels: action.paymentChannels,
    });
};

const updateUsers = (state, action) => {
    return updateState(state, {
        users: action.users,
        total: action.total,
    });
};

const updateFilter = (state, action) => {
    return updateState(state, {
        filter: action.filter,
    });
};

const updateSelectedUser = (state, action) => {
    return updateState(state, {
        selectedUser: action.selectedUser,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_PRODUCTS:
            return updateProducts(state, action);
        case actionTypes.UPDATE_PAYMENT_CHANNELS:
            return updatePaymentChannels(state, action);
        case actionTypes.UPDATE_USERS:
            return updateUsers(state, action);
        case actionTypes.UPDATE_ACCOUNTABILITY_FILTER:
            return updateFilter(state, action);
        case actionTypes.UPDATE_SELECTED_USER:
            return updateSelectedUser(state, action);
        default:
            return state;
    }
};

export default reducer;
